// 2GIS mapgl map. Public interface kept identical to the previous Google Maps
// implementation so call-sites (MapRoutes, TransferForm) need no changes.
// NB: mapgl uses [lng, lat] order; call-sites still pass Google-style
// [lat, lng] positions, so setMarker/setCarrierMarker flip them.

let mapInstance = null;

function twoGisKey () {
  return document.documentElement.dataset.gisKey || '';
}

window.GMap = class {
  constructor (id, isStatic) {
    this.isStatic = isStatic;

    const mapgl = window.mapgl;
    const $gmap = $(`#${id}`);

    const partner = $('body').attr('class').match(/gmap-pins-([a-z0-9\-_]+)/);
    this.partner = partner ? partner[1] : null;
    this.routeColor = $gmap.css('color') || '#31b700';

    this.markers = {
      from: { marker: null, icon: this.pinIcon('from') },
      to: { marker: null, icon: this.pinIcon('to') },
      carrier: { marker: null },
    };

    let div, map;
    if (mapInstance) {
      ({ div, map } = mapInstance);
      // Move the shared map container into this page's #gmap.
      $gmap.append(div);
    } else {
      div = document.createElement('div');
      div.style.width = '100%';
      div.style.height = '100%';
      // Append BEFORE creating the map so mapgl sees a sized, in-DOM container
      // (creating on a detached 0x0 div leaves the map blank until a resize).
      $gmap.append(div);
      map = new mapgl.Map(div, {
        center: [37.6173, 55.755826], // [lng, lat], Moscow
        zoom: 3,
        key: twoGisKey(),
      });
      mapInstance = { div, map };
    }

    this.map = map;
    this.routeLine = null;

    // can be overridden (TransferForm)
    this.updatedMarkerPosition = function (key, pos) {
      console.log('marker position updated', key, pos);
    };
  }

  pinIcon (direction) {
    // Reuse the website map pins already stored in S3. The host must be the one
    // that serves them directly: qa.rideclu.ru now 301s to rideclu.ru, and the
    // browser drops the cross-origin image on the redirect because the 301 has
    // no Access-Control-Allow-Origin — the pins silently vanished from the map.
    return `https://rideclu.ru/svg/map_pin_${direction}.svg`;
  }

  setOptions () {
    this.map.setCenter([37.6173, 55.755826]);
    this.map.setZoom(3);
  }

  // position: [lat, lng] (Google order) -> mapgl wants [lng, lat]
  setMarker (key, position) {
    this.clearMarker(key);
    if (position) {
      const coords = [Number(position[1]), Number(position[0])];
      const draggable = !Functions.isMobileDevice() && !this.isStatic;
      const marker = new window.mapgl.Marker(this.map, {
        coordinates: coords,
        icon: this.markers[key].icon,
        size: [54, 54],
        anchor: [27, 54],
        draggable,
      });
      if (draggable) {
        marker.on('dragend', () => {
          const c = marker.getCoordinates(); // [lng, lat]
          // Google-LatLng-like object: callers read .lat()/.lng()
          this.updatedMarkerPosition(key, { lat: () => c[1], lng: () => c[0] });
          this.zoomMarker();
        });
      }
      this.markers[key].marker = marker;
    }
    this.zoomMarker();
  }

  clearMarker (key) {
    const marker = this.markers[key].marker;
    if (marker) {
      marker.destroy();
      this.markers[key].marker = null;
    }
  }

  clearAllMarkers () {
    for (const key in this.markers) this.clearMarker(key);
  }

  zoomMarker () {
    const coords = [];
    for (const key in this.markers) {
      const marker = this.markers[key].marker;
      if (marker) coords.push(marker.getCoordinates());
    }

    if (coords.length === 0) return;

    if (coords.length === 1) {
      this.map.setCenter(coords[0]);
      this.map.setZoom(14);
      return;
    }

    const lngs = coords.map(c => c[0]);
    const lats = coords.map(c => c[1]);
    this.map.fitBounds(
      {
        southWest: [Math.min(...lngs), Math.min(...lats)],
        northEast: [Math.max(...lngs), Math.max(...lats)],
      },
      { padding: { top: 60, right: 60, bottom: 60, left: 60 } },
    );
  }

  // routeSteps: the /api/route_info payload; routes[0].overview_path = [[lng,lat],...]
  setRoute (routeSteps) {
    this.clearRoute();
    const path = routeSteps
      && routeSteps.routes
      && routeSteps.routes[0]
      && routeSteps.routes[0].overview_path;
    if (!path || !path.length) return;

    this.routeLine = new window.mapgl.Polyline(this.map, {
      coordinates: path,
      width: 5,
      color: this.routeColor,
    });
  }

  clearRoute () {
    if (this.routeLine) {
      this.routeLine.destroy();
      this.routeLine = null;
    }
    this.zoomMarker();
  }

  // position: [lat, lng]
  setCarrierMarker (position) {
    this.clearMarker('carrier');
    this.markers.carrier.marker = new window.mapgl.Marker(this.map, {
      coordinates: [Number(position[1]), Number(position[0])],
      icon: this.pinIcon('to'),
      size: [54, 54],
      anchor: [27, 54],
    });
  }

  destroy () {
    this.clearRoute();
    this.clearAllMarkers();
    this.setOptions();
  }
};
